import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SimiChatService } from '../../services/simi-chat.service';
import { ChartPopupComponent } from '../chart-popup/chart-popup.component';
import { MatDialog } from '@angular/material/dialog';
interface ChatMessage {
    sender: 'user' | 'ai';
    text?: string;
    selectBox?: boolean;
    table?: {
        columns: string[];
        data: any[];
        resultId?: any
    };
    graph?: any
    wantsChart?: boolean | null;
    timestamp?: string | null;
    question?: string
}
@Component({
    selector: 'app-chat-bot',
    templateUrl: './chat-bot.component.html',
    styleUrls: ['./chat-bot.component.scss']
})
export class ChatBotComponent implements OnInit {


    // Static credentials
    private readonly userName: string = 'admin';
    private readonly password: string = 'admin123';

    // Inputs/Outputs
    // @Input() userName1!: string;
    // @Input() passord!: string;
    @Output() closeDialogue = new EventEmitter();

    // Template references
    @ViewChild('chatBody', { static: false }) chatBody!: ElementRef;

    // State
    messages: ChatMessage[] = [];
    suggestions: string[] = [];
    userInput: string = '';
    isLoading: boolean = false;
    graph: any[] = [];

    // Chart config
    chartTypes: string[] = [
        "bar", "line", "scatter", "pie", "histogram", "box", "violin", "area",
        "heatmap", "bubble", "stacked_bar", "horizontal_bar", "donut", "multi_line", "grouped_bar"
    ];
    selectedChartType: string = 'bar';
    selectedXAxis: string = '';
    selectedYAxis: string = '';

    // Friendly greeting logic
    private readonly greetings = [
        'hi', 'hello', 'hey', 'hai', 'hii', 'helloo', 'hlo', 'hola',
        'good morning', 'good afternoon', 'good evening', 'gm', 'ga', 'ge',
        'yo', 'sup', 'whatsup', 'what’s up', 'heyy', 'heyy there',
        'greetings', 'howdy', 'namaste', 'welcome', 'hellooo', 'hey there', 'mng'
    ];
    private readonly friendlyReplies = [
        "Hello! 😊 How can I help you today?",
        "Hey there! 👋 Hope you're doing well!",
        "Hi! 😊 What’s on your mind?",
        "Hey! 👋 I'm here if you need anything.",
        "Hi there! 🌟 Let me know how I can assist.",
        "Hello! 👋 Feel free to ask me anything.",
        "Hey! 😊 Always happy to chat!",
        "Hi! ✨ Just say the word.",
        "Hello there! 👋 Let’s talk.",
        "Hi! 😊 Ready when you are!",
        "Hey friend! 👋 I’m here for you.",
        "Greetings! 😊 How can I assist?",
        "Hi! 😄 What’s up?",
        "Hello! 💬 Let’s chat.",
        "Hi! 👋 Ask me anything!"
    ];


    constructor(
        private _chatService: SimiChatService,
        private cdRef: ChangeDetectorRef,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.openChatbot();
    }

    closeDialog() {
        this.closeDialogue.emit();
    }

    openChatbot(): void {
        this.resetChartReqData()
        this.clearChatPopupData()
        this.resetSuggestions()

        const body: {
            username: string;
            password: string;
        } = {
            username: this.userName,
            password: this.password
        };

        this._chatService.loginToGetToken(body);

        this.messages.push({
            sender: 'ai',
            text: '...',
            timestamp: null
        });


        setTimeout(() => {
            this.messages.pop();
            this.messages.push({
                sender: 'ai',
                text: "Hello! I'm your AI assistant. I can help you with student data, attendance records, grade analysis, and answer questions about your classes. How can I assist you today?",
                timestamp: this.getCurrentTime()
            });


        }, 1000);
    }





    scrollToBottom() {
        if (!this.chatBody?.nativeElement) return;

        try {
            this.chatBody.nativeElement.scroll({
                top: this.chatBody.nativeElement.scrollHeight,
                behavior: 'smooth'
            });
        } catch (err) {
            console.warn('Scroll error:', err);
        }
    }

    private scrollAfterMessagesUpdate() {
        this.cdRef.detectChanges(); // Wait for DOM to update
        setTimeout(() => this.scrollToBottom(), 0); // Then scroll
    }


    private pushMessage(message: ChatMessage) {
        this.messages.push(message);
        this.scrollAfterMessagesUpdate();
    }

    private pushMultipleMessages(messages: any[]) {
        this.messages.push(...messages);
        this.scrollAfterMessagesUpdate();
    }





    getCurrentTime(): string {
        return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    useSuggestion(text: string) {
        this.userInput = text;
        this.onSendButtonClick()
    }

    // Sending message
    onSendButtonClick(): void {
        this.resetChartReqData();

        const input = this.userInput.trim().toLowerCase();
        if (!input || this.isLoading) return;

        this.pushMessage({ sender: 'user', text: this.userInput, timestamp: this.getCurrentTime() });

        if (this.greetings.includes(input)) {
            const reply = this.friendlyReplies[Math.floor(Math.random() * this.friendlyReplies.length)];
            this.pushMessage({ sender: 'ai', text: reply, timestamp: this.getCurrentTime() });
            this.userInput = '';
            this.resetSuggestions();
            return;
        }

        this.fetchBotResponse();
        this.resetSuggestions();
    }



    fetchBotResponse() {
        if (!this.userInput.trim()) return;

        this.isLoading = true;
        const body = { question: this.userInput };

        this._chatService.sendQuery(body).subscribe({
            next: (res) => {
                this.isLoading = false;
                this.userInput = '';
                const timestamp = this.getCurrentTime();

                if (!res.success && res.error) {
                    this.pushMessage({
                        sender: 'ai',
                        text: `${res.error}`,
                        timestamp
                    })



                    if (res.suggestions?.length) {
                        this.suggestions = res.suggestions;
                    }
                    return;
                }

                if (res.columns && res.data?.length === 0) {
                    const message: any = {
                        sender: 'ai',
                        text: res.message || 'No records found.',
                        timestamp
                    };

                    if (res.alternative_queries?.length) {
                        this.suggestions = res.alternative_queries;
                        message.text += ' Please check the suggestions below.';
                    }

                    this.pushMessage(message)
                    return;
                }

                if (res.columns && res.data?.length) {
                    const processedData = res.data.map((row: any) => {
                        const newRow: any = {};
                        for (const col of res.columns) {
                            const value = row[col];
                            newRow[col] = {
                                value: this.isImagePath(value) ? this.getFullImageUrl(value) : value,
                                isImage: this.isImagePath(value)
                            };
                        }
                        return newRow;
                    });

                    let tableObj: any = {
                        columns: res.columns,
                        data: processedData,
                        resultId: res?.result_id
                    }

                    let tableObjWithoutData: any = {
                        columns: res.columns,
                        resultId: res?.result_id
                    }


                    this.pushMessage({
                        sender: 'ai',
                        table: {
                            ...tableObj
                        },
                        wantsChart: null,
                        timestamp,
                        graph: null
                    })


                    this.pushMessage({
                        sender: 'ai',
                        question: 'chart',
                        text: "Would you like to see a graphical representation of this data?",
                        table: {
                            ...tableObjWithoutData
                        },
                        timestamp
                    })

                    this.suggestions = []
                }




                if (res.text) {
                    this.pushMessage({
                        sender: 'ai',
                        text: res.text,
                        timestamp
                    })
                }

                if (res.alternative_queries?.length) {
                    this.suggestions = res.alternative_queries;
                }

                if (res.suggestions?.length) {
                    this.suggestions = res.suggestions;
                }
            },

            error: (err) => {
                this.isLoading = false;
                this.userInput = '';
                const timestamp = this.getCurrentTime();

                if (err?.error?.error && err?.error?.suggestions?.length) {
                    this.pushMessage({
                        sender: 'ai',
                        text: `⚠️ Please try one of the suggestions below.`,
                        timestamp
                    })

                    const quoteSuggestions = err.error.suggestions.flatMap((s: string) => {
                        const matches = s.match(/"([^"]+)"/g);
                        return matches?.map(x => x.replace(/"/g, '')) || [];
                    });

                    if (quoteSuggestions.length > 0) {
                        this.suggestions = quoteSuggestions;
                    }
                } else {
                    this.pushMessage({
                        sender: 'ai',
                        text: '⚠️ Something went wrong. Please try again later.',
                        timestamp
                    })
                }

                console.error('Chatbot API error:', err);
            }
        });
    }

    clearChatPopupData() {
        this.messages = []
        this.userInput = ""
        this.isLoading = false;
        this.suggestions = []
    }
    resetSuggestions() {

        this.suggestions = [
            "Show me data from students who are from Kerala",
            "Show me all customers", 'show me the first 10 customers', 'list staff'];
    }

    isImage(value: string): boolean {
        return typeof value === 'string' && value.match(/\.(jpeg|jpg|gif|png|webp|svg)$/i) !== null;
    }

    isImagePath(value: string): boolean {
        return typeof value === 'string' && value.match(/\.(jpeg|jpg|gif|png|webp|svg)$/i) !== null;
    }

    getFullImageUrl(path: string): string {
        let baseUrl: string = 'https://simibot.edship.in';

        if (path.startsWith('http')) {
            return path;
        }

        return `${baseUrl}${path}`;
    }



    resetChartReqData() {
        this.selectedChartType = 'bar';
        this.selectedXAxis = '';
        this.selectedYAxis = '';
        this.graph = []
    }


    // Triggered when any dropdown value changes
    onChartOptionChange(index: any) {
        if (!this.selectedXAxis || !this.selectedYAxis || !this.selectedChartType || this.isLoading) return;

        this.isLoading = true;


        let result_id: any = this.messages[this.messages.length - 1]?.table?.resultId;

        const chartColors: string[] = [
            "blue", "red", "green", "orange", "purple",
            "yellow", "cyan", "magenta", "brown", "pink"
        ];



        const randomColor = chartColors[Math.floor(Math.random() * chartColors.length)];

        const body = {

            "result_id": result_id,
            "chart_config": {
                "chart_type": this.selectedChartType,
                "x_axis": this.selectedXAxis,
                "y_axis": this.selectedYAxis,
                "color": randomColor
            }


        };
        this.scrollAfterMessagesUpdate();

        this._chatService.getGraphData(body).subscribe({
            next: (res: any) => {
                if (res) {
                    res.chart_json.layout = {
                        ...res.chart_json.layout,
                        height: 250,
                        width: 400
                    };
                    this.graph.push(res.chart_json);

                    if (this.messages[index]?.graph) {
                        this.messages[index]!.graph = this.graph;
                    }

                    this.scrollAfterMessagesUpdate();
                    this.resetSuggestions();

                    console.log("message", this.messages);

                } else {
                    this.pushMessage({
                        sender: 'ai',
                        text: '⚠️ No data available to display the chart.',
                        timestamp: this.getCurrentTime()
                    });
                }

                this.isLoading = false;


            },
            error: (err) => {
                this.pushMessage({
                    sender: 'ai',
                    text: '⚠️ Something went wrong. Please try again later.',
                    timestamp: this.getCurrentTime()
                })
                this.isLoading = false;
            }
        });

    }

    shouldAskChart(i: number): boolean {
        console.log("SHOW")
        const lastMessage = this.messages[i];

        // Check if the last message is from AI and contains specific text
        if (lastMessage?.sender === 'ai' && lastMessage?.text?.includes('graphical representation') && lastMessage?.question === 'chart') {
            return true;
        }

        // Optionally, check the last AI message in the entire history
        const lastAIMessage = [...this.messages].reverse().find((msg: any) => msg.sender === 'ai');
        return !!(lastAIMessage?.text?.includes('graphical representation')) && lastAIMessage?.wantsChart === null && lastMessage?.question === 'chart';
    }


    handleChartPreference(wantsChart: boolean) {
        const tableMsg = [...this.messages].reverse().find(msg => msg.sender === 'ai' && msg.table);

        if (tableMsg?.table) {
            tableMsg.wantsChart = wantsChart;
        }

        let tableObj: any = { ...this.messages[this.messages.length - 1]?.table }
        delete tableObj.data;

        this.pushMessage({
            sender: 'user',
            text: wantsChart ? 'Yes' : 'No',
            timestamp: this.getCurrentTime(),
            table: { ...tableObj }
        })

        if (!wantsChart) {
            this.pushMessage({
                sender: 'ai',
                text: "Alright! Let me know if you need anything else.",
                timestamp: this.getCurrentTime()
            })
            this.resetSuggestions()
        } else {
            this.pushMessage({
                sender: 'ai',
                text: '',
                selectBox: true,
                graph: [],
                table: { ...tableObj },
                timestamp: this.getCurrentTime()
            })

            this.suggestions = []
        }




    }



    openChartPopup(graph: any) {
        this.dialog.open(ChartPopupComponent, {
            width: '800px',
            height: '600px',
            data: { type: 'chart', graph }
        });
    }

    openTablePopup(table: any) {
        this.dialog.open(ChartPopupComponent, {
            width: '800px',
            height: '600px',
            data: { type: 'table', table }
        });
    }




}
